import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import './App.css';
import BottomBar from './components/BottomBar';
import Home from './pages/Home'; 
import Service from './pages/Service';
import Trading from './pages/Trading'; 
import Mine from './pages/Mine'; 
import Register from './pages/Register';
import Login from './pages/Login';
import AdminPanel from './admin/AdminPanel';
import Loader from './components/Loader';
import SplashScreen from './components/SplashScreen';
import Deposit from './pages/Deposit';
import Withdraw from './pages/Withdraw'; 
import PaymentMethod from './pages/PaymentMethod';
import Settings from './pages/Settings';
import History from './pages/History';

const UserLayout = () => {
  const [activeTab, setActiveTab] = useState('home');
  const [selectedCoin, setSelectedCoin] = useState(null);
  const [isPageLoading, setIsPageLoading] = useState(false);
  const location = useLocation();

  useEffect(() => {
    if (location.state && location.state.activeTab) {
      setActiveTab(location.state.activeTab);
    }
  }, [location.state]);

  const handleCoinClick = (coin) => {
    setIsPageLoading(true);
    setSelectedCoin(coin);
    setActiveTab('trading');
    setTimeout(() => setIsPageLoading(false), 800);
  };

  const handleTabChange = (tab) => {
    if (tab !== activeTab) {
      setIsPageLoading(true);
      setActiveTab(tab);
      setTimeout(() => setIsPageLoading(false), 500); 
    }
  };

  const isDarkPage = activeTab === 'trading';

  return (
    <div className="App" style={{ 
      backgroundColor: isDarkPage ? '#000000' : '#f8f9fb', 
      minHeight: '100vh',
      transition: 'background-color 0.3s ease' 
    }}>
      {isPageLoading && <div className="loader-overlay"><Loader /></div>}
      <div className="content-area">
        {activeTab === 'home' && <Home onCoinClick={handleCoinClick} />}
        {activeTab === 'service' && <Service />}
        {activeTab === 'trading' && <Trading initialCoin={selectedCoin} />}
        {activeTab === 'mine' && <Mine />}
      </div>
      <BottomBar activeTab={activeTab} setActiveTab={handleTabChange} />
    </div>
  );
};

function App() {
  const [showSplash, setShowSplash] = useState(false);
  // Isay state mein rakha taake login hote hi App reload ho
  const [isAuthenticated, setIsAuthenticated] = useState(!!localStorage.getItem('user'));

  useEffect(() => {
    const hasShownSplash = sessionStorage.getItem('splashShown');
    if (!hasShownSplash) {
      setShowSplash(true);
      const timer = setTimeout(() => {
        setShowSplash(false);
        sessionStorage.setItem('splashShown', 'true');
      }, 2500); 
      return () => clearTimeout(timer);
    }

    // Listener for login/logout changes
    const checkAuth = () => {
      setIsAuthenticated(!!localStorage.getItem('user'));
    };

    window.addEventListener('storage', checkAuth);
    return () => window.removeEventListener('storage', checkAuth);
  }, []);

  return (
    <>
      {showSplash && <SplashScreen />}
      
      <Router>
        <Routes>
          {/* ✅ Check State instead of direct localStorage */}
          <Route path="/" element={isAuthenticated ? <UserLayout /> : <Navigate to="/login" />} />
          
          <Route path="/login" element={!isAuthenticated ? <Login /> : <Navigate to="/" />} />
          <Route path="/register" element={!isAuthenticated ? <Register /> : <Navigate to="/" />} />
          
          <Route path="/admin" element={<AdminPanel />} />
          <Route path="/dashboard" element={isAuthenticated ? <UserLayout /> : <Navigate to="/login" />} />
          
          <Route path="/deposit" element={isAuthenticated ? <Deposit /> : <Navigate to="/login" />} />
          <Route path="/withdraw" element={isAuthenticated ? <Withdraw /> : <Navigate to="/login" />} />
          <Route path="/payment-method" element={isAuthenticated ? <PaymentMethod /> : <Navigate to="/login" />} />
          <Route path="/settings" element={isAuthenticated ? <Settings /> : <Navigate to="/login" />} /> 
          <Route path="/service" element={isAuthenticated ? <Service /> : <Navigate to="/login" />} />
          <Route path="/history" element={isAuthenticated ? <History /> : <Navigate to="/login" />} />

          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </Router>
    </>
  );
}

export default App;